import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from '../commons/cart.service';
import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';
import { ScrollService } from '../commons/scroll.service';

@Component({
  template: require('./select-dimensions.component.html'),
  styles: [`
      label { display:block; }
      select{ margin-bottom:20px;}
      .btn-success{ margin-right:10px;}
  `]
  // , changeDetection: ChangeDetectionStrategy.OnPush
})



// require 'mailup'

// credentials = {
//   client_id: ENV['MAILUP_CLIENT_ID'],
//   client_secret: ENV['MAILUP_CLIENT_SECRET'],
//   oauth: {
//     token: "...",
//     refresh_token: "...",
//     expires_at: 1234567890
//   }
// }

// mailup = MailUp::API.new(credentials)

export class SelectDimensionsComponent implements OnInit {

  constructor(
    private config: ConfigService,
    private cartService: CartService,
    public session: SessionService,
    private router: Router,
    private scroll: ScrollService
  ) { }

  ngOnInit() {
    this.cartService.cartCheckProducts();

    if (!this.cartService.cart.currentCartProduct.photoOriginal) {
      //console.log('no photoOriginal - redirect upload-photo');
      this.router.navigate(['/upload-photo']);
    } else {
      let that = this;
      setTimeout(function () {
        if (that.cartService.cart.formatoSelected === false) {
          let formatoDispPiuBIG = document.getElementById(that.cartService.cart.currentCartProduct.format.split('|')[0]);
          let rigaFormatoBIG = formatoDispPiuBIG.getElementsByClassName('riga-input hidden formatOK');
          let numeroMedio = ((rigaFormatoBIG.length - 1) / 2).toFixed();

          that.scroll.simulatedClick((rigaFormatoBIG[numeroMedio]));
          setTimeout(function () {
            alert('Caricando una nuova foto è stata cambiata la selezione del formato');

            let posY = $('.riga-input.formatOK.active').offset().top;
            $('html, body').animate({scrollTop: posY}, 'slow');

          }, 100);
        }
        // let BoxSelected = document.getElementById(that.cartService.cart.currentCartProduct.format);
        // that.scroll.simulatedClick(BoxSelected);
      }, 800);
    }
  }

}






// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/select-dimensions.component.ts